export default __webpack_public_path__ + "media/images/admin-hover-f36edb9122ac5cf502e5fe0516535a4b.png";